<template>
  <gj-modal
      :visible.sync="modalVisible"
      :destroyOnClose="true"
      size="full"
      :noPadding="true"
      style="padding: 0 10px"
      :content-style="{height: '100%'}"
      :confirm-loading="loading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      <span>批量调价</span>
    </template>
    <template #content>
      <div class="offer--content">

        <div class="offer--setting">
          <el-form :model="form" ref="form" label-width="100px">

            <el-form-item
                prop="email"
                label="调价方式"
                style="margin-bottom: 10px;">
              <el-radio-group v-model="type" @change="radioChange">
                <el-radio :label="0">统一定价</el-radio>
                <el-radio :label="1">金额调价</el-radio>
                <el-radio :label="2">百分比调价</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-row type="flex">

              <el-form-item
                  class="el-item-inline"
                  prop="price"
                  label="原价"
                  :rules="[
                    type===2?$gjReRule(/^([1-9]\d|\d)$/, '请输入0-99整数') : $gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数'),
                    type===0?$gjMinRule(form.salePrice, '不可低于优惠价'):{}
                  ]"
              >
                <!--                上调下调select-->
                <gj-select class="no-left-radius" v-if="type!==0" :filterable="false" :clearable="false" width="70px" v-model="priceChange"
                           :options="option"></gj-select>
                <gj-input :class="{'no-left-border': type !== 0}" width="120px" v-model="form.price" @change="verify">
                  <template #append>
                      <span v-if="type===2">%</span>
                  </template>
                </gj-input>
              </el-form-item>

              <el-form-item
                  class="el-item-inline"
                  prop="salePrice"
                  label="优惠价"
                  label-width="80px"
                  :rules="[
                    type===2?$gjReRule(/^([1-9]\d|\d)$/, '请输入0-99整数') : $gjReRule(RE.num(2), '请输入正确的数值,最多保留两位小数'),
                    (type===0&&(form.price==='0'||form.price>0))?$gjMaxRule(form.price, '不可超过原价'):{},
                  ]"
              >
                <!--                上调下调select-->
                <gj-select class="no-left-radius" v-if="type!==0" :filterable="false" :clearable="false" width="70px"
                           v-model="saleChange" :options="option"></gj-select>

                <gj-input :class="{'no-left-border': type !== 0}" width="120px" v-model="form.salePrice" @change="verify">
                  <template #append>
                      <span v-if="type===2">%</span>
                  </template>
                </gj-input>
              </el-form-item>

              <el-form-item
                  class="el-item-inline"
                  label="优惠时间"
                  label-width="92px"
              >
                <gj-date-picker
                    type="daterange"
                    v-model="form.saleDate"
                    width="200px"
                ></gj-date-picker>
              </el-form-item>

              <div class="flex align-center" style="padding-left: 16px;" v-if="type===2">
                <gj-checkbox v-model="keep"></gj-checkbox>
                <span style="padding: 0 4px;">保留小数点后尾数不变</span>
                <gj-tooltip content="在原值基础上按百分比进行调价，调整后的价格的整数部分取计算后得出的数值的整数部分，小数点后的尾数与原值一样">
                  <i class="iconfont iconwenhao" style="font-size: 14px;"></i>
                </gj-tooltip>
              </div>

              <div class="apply-btn">
                <gj-button @click="resolve">应用</gj-button>
              </div>

            </el-row>
          </el-form>
        </div>

        <el-form
            :model="tableForm"
            ref="tableForm"
            style="display: flex; height: 100%;">
          <div class="offer--table">
            <gj-table
                name="relate-product"
                :data="tableForm.items"
                :columns="columns"
                :size="'has-picture'"
                :offsetHeight="74">

              <template v-slot:asin="{ row }">
                <gj-tooltip :text-line="1" :content="row.title">
                  {{ row.title }}
                </gj-tooltip>

                <div class="asin-msku_list">
                  <div class="asin_list">
                    <a :href="row.asinUrl" target="_blank">{{ row.asin }}</a>
                    <span v-if="row.asin" v-copy="row.asin" class="copy-icon gj-cell-display-switch">
                      <gj-icon class="el-icon-copy-document"></gj-icon>
                    </span>
                  </div>
                  <div class="msku_list">
                    <gj-tooltip :text-line="1" :content="row.msku">
                      {{ row.msku || '-' }}
                    </gj-tooltip>
                    <span v-copy="row.msku" v-if="row.msku"
                          class="copy-icon gj-cell-display-switch">
                      <gj-icon class="el-icon-copy-document"></gj-icon>
                    </span>
                  </div>
                </div>
              </template>

              <template v-slot:yourPrice="{ row, index }">
                <el-form-item
                    :prop="`items.${index}.yourPrice`"
                    :rules="[
                      $gjReRule(RE.num(2), '请输入正确的数值，最多保留两位小数'),
                      $gjMinRule(row.salePrice, '不可低于优惠价'),
                    ]"
                    class="gj-table-item">
                  <gj-input
                      style="z-index: 1;"
                      width="120px"
                      @change="tableVerify"
                      v-model="row.yourPrice">
                    <template slot="prepend">{{ row.currencySymbol }}</template>
                  </gj-input>
                </el-form-item>
              </template>

              <template v-slot:salePrice="{ row, index }">
                <el-form-item
                    :prop="`items.${index}.salePrice`"
                    :rules="[
                    $gjReRule(RE.num(2), '请输入正确的数值，最多保留两位小数'),
                    (row.yourPrice==='0'||row.yourPrice>0)?$gjMaxRule(row.yourPrice, '不可超过原价'):{},
                  ]"
                    class="gj-table-item">
                  <gj-input
                      style="z-index: 1;"
                      width="120px"
                      @change="tableVerify"
                      v-model="row.salePrice"
                  >
                    <template slot="prepend">{{ row.currencySymbol }}</template>
                  </gj-input>
                </el-form-item>
              </template>

              <template v-slot:saleDate="{row}">
                <gj-date-picker
                    type="daterange"
                    v-model="row.saleDate"
                    width="200px"
                ></gj-date-picker>
              </template>

              <template v-slot:op="{ index, row }">
                <template v-if="tableForm.items.length !== 1">
                  <gj-button type="text" @click="deleteItem(index, row)">删除</gj-button>
                </template>
              </template>
            </gj-table>
          </div>
        </el-form>

      </div>
    </template>
  </gj-modal>
</template>

<script>
import {formRuleMixin, modalMixIn} from "../../../../../minxins";
import {batchUpdatePrice} from "../../../../../api/sale";

export default {
  name: "app-product-offer-modal",
  mixins: [modalMixIn, formRuleMixin],
  props: {
    rows: null,
  },
  created() {
    this.tableForm.items = this._.cloneDeep(this.rows);
  },
  data() {
    return {
      form: {
        price: null,
        salePrice: null,
        saleDate: []
      },

      priceChange: 'up', //up  down
      saleChange: 'up', //up  down

      keep:false,

      option: [
        {id: 'up', text: '上调'},
        {id: 'down', text: '下调'}
      ],
      tableForm: {
        items: [],
      },
      columns: [
        {id: 'picture', header: '图片', field: 'picture:imageUrl', minWidth: '50px'},
        {id: 'asin', header: '商品标题/ASIN/父ASIN', field: 'slot:asin', minWidth: '250px'},
        {id: 'msku', header: 'MSKU', field: 'msku', minWidth: '120px'},
        {id: 'price', header: '原价', field: 'slot:yourPrice', minWidth: '120px'},
        {id: 'salePrice', header: '优惠价', field: 'slot:salePrice', minWidth: '120px'},
        {id: 'saleDate', header: '优惠时间', field: 'slot:saleDate', minWidth: '200px'},
        {id: 'op', header: '操作', field: 'slot:op', width: '80px', notCustomColumn: true}
      ],
      type: 0,
      loading: false,
    }
  },
  methods: {
    verify(){
      this.$nextTick(()=>{
        this.$refs.form.validate()
      })
    },
    tableVerify(){
      this.$nextTick(()=>{
        this.$refs.tableForm.validate()
      })
    },
    radioChange(){
      this.form.price='';
      this.form.salePrice='';
    },
    deleteItem(index) {
      this.tableForm.items.splice(index, 1);
    },
    resolve() {
      if (this.$gjFormValidate()) {
        // if (this.type !== 0 && !this.tableFormValidate()) {
        //   return;
        // }
        this.tableForm.items.forEach(v => {
          // 统一定价
          if (this.type === 0) {
            if(this.form.price==='0'||this.form.price>0){
              v.yourPrice = this.form.price;
            }

            if(this.form.salePrice==='0'||this.form.salePrice>0){
              v.salePrice = this.form.salePrice;
            }

          }
          // 金额调价
          else if (this.type === 1) {
            if(this.form.price==='0'||this.form.price>0){
              if (this.priceChange === 'up') {
                v.yourPrice = this.calc(this.form.price, v.yourPrice, true);
              } else {
                v.yourPrice = this.calc(v.yourPrice, this.form.price, false);
              }
            }

            if(this.form.salePrice==='0'||this.form.salePrice>0){
              if (this.saleChange === 'up') {
                v.salePrice = this.calc(this.form.salePrice, v.salePrice, true);
              } else {
                v.salePrice = this.calc(v.salePrice, this.form.salePrice, false);
              }
            }

          }
          // 百分比调价
          else if (this.type === 2) {
            if(this.form.price==='0'||this.form.price>0){
              if (this.priceChange === 'up') {
                v.yourPrice = this.percentCale(this.form.price, v.yourPrice, true);
              } else {
                v.yourPrice = this.percentCale(this.form.price, v.yourPrice, false);
              }
            }

            if(this.form.salePrice==='0'||this.form.salePrice>0){
              if (this.saleChange === 'up') {
                v.salePrice = this.percentCale(this.form.salePrice, v.salePrice, true);
              } else {
                v.salePrice = this.percentCale(this.form.salePrice, v.salePrice, false);
              }
            }

          }

          v.saleDate = this.form.saleDate

        })
      }
    },
    calc(val1, val2, type) {
      if (type) {
        return (Number(val1) + Number(val2)).toFixed(2)
      } else {
        return (Number(val1) - Number(val2)).toFixed(2)
      }
    },
    percentCale(val1, val2, type) {
      //若保留小数不变
      if(this.keep){
        let val = val2.split('.');
        let num;
        if (type) {
          num = ( (1 + Number(val1) / 100) * Number(val[0])).toString().split('.')
          if(val.length>1){
            return num[0] + '.' + val[1];
          }else {
            return num[0]
          }


        } else {
          num = ( (1 - Number(val1) / 100) * Number(val[0])).toString().split('.')
          if(val.length>1){
            return num[0] + '.' + val[1];
          }else {
            return num[0]
          }
        }
      }
      //若不保留小数
      else{
        if(type){
          return ((1 + Number(val1) / 100) * Number(val2)).toFixed(2)
        }else {
          return ((1 - Number(val1) / 100) * Number(val2)).toFixed(2)
        }
      }

    },
    regCheck(value) {
      const reg = /^[0-9]+(.?[0-9]{1,2})?$/;
      return reg.test(value)
    },
    confirm() {
      if (this.tableFormValidate()) {
        this.loading = true;
        batchUpdatePrice({
          items: this.tableForm.items.map(v => {
            return {
              marketId: v.marketId,
              id: v.listingId || v.id,
              salePrice: v.salePrice,
              yourPrice: v.yourPrice,
              saleStartDate: v.saleDate[0],
              saleEndDate: v.saleDate[1],
            }
          })
        })
            .then(() => {
              this.$emit('after');
            }).complete(() => this.loading = false)
      }
    },
    tableFormValidate() {
      let formValid = false;
      this.$refs.tableForm.validate((valid) => {
        formValid = valid;
      });
      return formValid;
    }
  }
}
</script>

<style lang="scss" scoped>

/deep/ .gj-table--has-picture td:not(.vxe-footer--column){
  height: 65px!important;
}

.offer--content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.offer--setting {
  padding: 10px 20px 16px 10px;
}

.offer--table {
  flex: 1;
  margin: 0 20px;
  /* border-top: 1px solid #EBEEF5; */
}

.el-item-inline {
  margin-bottom: 0;
}

.apply-btn {
  margin-left: 20px;
  padding-top: 0;
}

.asin-msku_list {
  display: flex;

  a {
    color: #1F6EEF;
    text-decoration-line: none;
  }

  .asin_list {
    flex: 10;
  }

  .msku_list {
    flex: 14;

    /deep/ .gj-tooltip {
      max-width: 86%;
    }
  }
}
.no-left-border{
  /deep/ .el-input__inner{
    border-left-color: transparent;
    &:hover, &:focus{
      border-left-color: #1F6EEF
    }
  }
}
.no-left-radius{
  /deep/ .el-input__inner{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>
